export default __webpack_public_path__ + "static/media/water-disc2.f6600be6.png";